import PrimaryButton from "components/common/Button/PrimaryButton";
import { accent400, primary300 } from "constantVariables";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import React from "react";
import styles from "./index.module.scss";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useAddPersonalAI } from "hooks/personalai";
import { addSinglePersonalAISuccess } from "store/slices/personalai";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

const ApplyNow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { language } = useAppSelector(getSettings);
  const { mutate: addPersonalAI } = useAddPersonalAI(language);
  const { tabHandler } = useLifeChoicePageContext();
  const {
    lifeChoice: { _id, title, profile_images, is_major },
  } = useLifeChoicePageContext();
  const isThisTheRightPathForMe = () => {
    const id = new Date().getTime();
    dispatch(addSinglePersonalAISuccess({ 
      major: {
        title,
        profile_images: profile_images.map((image) => image.split("/").pop()),
        is_major,
      },
      id,
      createdAt: new Date().toISOString(),
     }));
     addPersonalAI({ id: _id, tempID: id });
    navigate("/personal-ai?tab=recommendations");
  };
  return (
    <div className={`${styles["apply-now"]} | container`}>
      <PrimaryButton
        color={primary300}
        onClick={() => tabHandler("apply")}
        className="rounded-lg py-3"
      >
        {t("applyNowButton")}
      </PrimaryButton>
      <PrimaryButton
        color={accent400}
        onClick={isThisTheRightPathForMe}
        className="rounded-lg py-3"
      >
        {t("isThisTheRightPathForMeButton")}
      </PrimaryButton>
    </div>
  );
};

export default ApplyNow;
